import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import InvoiceList from "../InvoiceList";

function AdminDues(){
    const[searchUi,setSearchUi]=useState(true)
    const[searchContent,setSearchContent]=useState('')
    
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={4}
        childrenPage={<InvoiceList/>}/>
        </DataContext.Provider>
    )
}

export default AdminDues;